import { gql } from '@apollo/client'

export const FLAG_CLASSIFICATION_CROP = gql`
  mutation FlagClassificationCrop($input: FlagClassificationCropInput!) {
    flagClassificationCrop(input: $input) {
      __typename
      ... on ClassificationFlagCropResult {
        boundingBox {
          id
          isFlagged
          leasedById
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
        }
      }
    }
  }
`
